import {
    Dialog,
    DialogContent,
    TableBody,
    TableCell,
    TableHead,
    TableRow
  } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { CurrencyrateEvent } from "@saleor/currencyrate/types/CurrencyrateEvent";
import { renderCollection } from "@saleor/misc";
import React from "react";
import { FormattedMessage } from "react-intl";

export interface EventDialogProps{
    data: CurrencyrateEvent
    open: boolean;
    onClose: () => void;
}


const EventDialog:React.FC<EventDialogProps> = ({
    data,
    open,
    onClose,
})=>(
        <>
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="md">
            <DialogTitle>
                <FormattedMessage defaultMessage="Currency Event" />
            </DialogTitle>
            <DialogContent style={{overflowY:"scroll",height:"550px"}}>
                <TableHead >
                    <TableCellHeader style={{ width:"240px"}}>
                        <FormattedMessage defaultMessage="User" />
                    </TableCellHeader>
                    <TableCellHeader style={{ width:"240px"}}>
                        <FormattedMessage defaultMessage="Operation" />
                    </TableCellHeader>
                    <TableCellHeader style={{ width:"240px"}}>
                        <FormattedMessage defaultMessage="Currency" />
                    </TableCellHeader>
                    <TableCellHeader style={{ width:"240px"}}> 
                        <FormattedMessage defaultMessage="DateTime" />
                    </TableCellHeader>
                </TableHead>
                <TableBody>
                    {renderCollection(
                        data?.currencyrateEvent,
                        item =>(
                                <TableRow
                                    key={item ? item.id : "skeleton"}
                                >
                                    <TableCell>
                                        {item ? item.user : <Skeleton />}
                                    </TableCell>
                                    <TableCell>
                                        {item ? item.type : <Skeleton />}
                                    </TableCell>
                                    <TableCell>
                                        {item ? item.currencyrate : <Skeleton />}
                                    </TableCell>
                                    <TableCell>
                                        {item ? item.date: <Skeleton />}
                                    </TableCell>
                                </TableRow>
                            )
                    )
                        
                    }
                </TableBody>
            </DialogContent>
           
        </Dialog>
        </>
    )

export default EventDialog